<div class="card b-0 mt-lg-1 mt-3 border rounded">
  <div class="card-body p-3">
    <div class="row">
      <div class="col-12 col-lg-7">
        <fgbcl-date-range-picker [(startDate)]="transactionStartDate" [(endDate)]="transactionEndDate"></fgbcl-date-range-picker>
      </div>
      <div class="col-12 col-lg-3 offset-lg-2">
        <button type="button" class="search-button fw-bold d-block border-0 text-white bg-black" (click)="search()">
          Search
        </button>
      </div>
    </div>
  </div>
</div>

<fgb-transaction-list
  *ngIf="selectedValues"
  [startDate]="selectedValues.start"
  [endDate]="selectedValues.end"
  [memberId]="memberId"
  [transactionType]="selectedValues.type"
></fgb-transaction-list>
